/* Ajusta el tamano del texto de la vista previa segun cuantas letras tenga.
   El CSS hace el trabajo con reglas [data-len]; aqui solo se escribe el numero.
   Va aparte de los scripts de personalizacion para que aplique en las dos
   pantallas donde vive la vista previa (ficha de pelota y ficha del servicio)
   sin duplicar logica. */
(function () {
  function sync() {
    var nodes = document.querySelectorAll('[data-mb-perso-text]');
    for (var i = 0; i < nodes.length; i++) {
      var n = (nodes[i].textContent || '').trim().length;
      if (n > 5) n = 5;
      if (n > 0) {
        nodes[i].setAttribute('data-len', String(n));
      } else {
        nodes[i].removeAttribute('data-len');
      }
    }
  }

  function bind() {
    document.querySelectorAll('[data-mb-perso-input]').forEach(function (input) {
      if (input.dataset.mbSizeBound === '1') return;
      input.dataset.mbSizeBound = '1';
      ['input', 'change', 'blur', 'keyup'].forEach(function (ev) {
        input.addEventListener(ev, function () { setTimeout(sync, 0); });
      });
    });
    sync();
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  if (document.readyState !== 'loading') bind();
  setTimeout(bind, 600);
  setTimeout(bind, 1800);

  if (window.MutationObserver) {
    document.addEventListener('DOMContentLoaded', function () {
      var scope = document.querySelector('.product__info-container') || document.body;
      new MutationObserver(function () { bind(); }).observe(scope, { childList: true, subtree: true });
    });
  }
})();
